/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { SlideStatusChange } from './SlideStatusChange';

export type AdminCaseListSlide = {
    readonly id?: number;
    /**
     * status of a slide until it's fully imported and visible to a user in 'success'. History logged by SlideStatusChange.
     */
    status?: AdminCaseListSlide.status;
    readonly status_changes?: Array<SlideStatusChange>;
    readonly block_obj_id?: number;
    readonly specimen_id?: number;
    readonly stain_id?: number;
    /**
     * slide number in the provided block
     */
    slide_number?: string | null;
    is_control?: boolean;
    is_rescan?: boolean;
}

export namespace AdminCaseListSlide {

    /**
     * status of a slide until it's fully imported and visible to a user in 'success'. History logged by SlideStatusChange.
     */
    export enum status {
        RECEIVED_WPL = 'received-wpl',
        RECEIVED_LAB = 'received-lab',
        PENDING = 'pending',
        PRECOMPUTING = 'precomputing',
        UPLOADED = 'uploaded',
        ERROR = 'error',
        MANUAL_MERGE = 'manual-merge',
        MANUAL_REVIEW = 'manual-review',
        SUCCESS = 'success',
        PENDING_AI = 'pending-ai',
        DELETED = 'deleted',
        ARCHIVED = 'archived',
        ON_HOLD = 'on-hold',
    }


}
